module.exports = __webpack_public_path__ + "images/status_selection.gif";